import { VIDEO_TYPE } from "./../ricos-content/index.js";
import { unreachable } from "./../ricos-content/ts-utils.js";
import { logInvariant } from "./../_shared/log-invariant.js";
import { upload } from "./../_shared/upload/upload.js";
import { RICOS_DEFAULTS } from "./constants.js";
const getVideoAttributes = ({
  uploadData,
  componentData,
  config
}) => {
  const { pathname, thumbnail: uploadedThumbnail, url: uploadedUrl, title } = uploadData;
  const src = pathname ? { id: pathname } : { url: uploadedUrl };
  const thumbnailObject = uploadedThumbnail ? {
    thumbnail: {
      src: { id: uploadedThumbnail.pathname },
      width: uploadedThumbnail.width,
      height: uploadedThumbnail.height
    }
  } : {};
  const titleObject = title ? { title } : {};
  return {
    video: { src },
    ...thumbnailObject,
    ...titleObject,
    disableDownload: componentData?.video?.src ? componentData.disableDownload : config.disableDownloadDefault || null
  };
};
const getVideoPickMedia = ({
  services,
  config
}) => {
  const { handleFileUpload, handleFileSelection } = config;
  const devPickMedia = services.devService().pickMedia;
  return devPickMedia ? devPickMedia : handleFileSelection ? async () => {
    const data = await new Promise(
      (resolve) => handleFileSelection(({ data: data2 }) => resolve(data2))
    );
    return { type: "ready-media", media: [data] };
  } : async ({ mimeType, multiple }) => {
    const files = await services.uploadService?.selectFiles({ accept: mimeType, multiple }) ?? [];
    return { type: "file", file: files, customUploadFn: handleFileUpload };
  };
};
const handleVideoUpload = async ({
  services,
  config,
  publicCommands,
  nodeId
}) => {
  const { handleFileUpload } = config;
  const pickMedia = getVideoPickMedia({ services, config });
  const result = await pickMedia({ mimeType: "video/*", multiple: false });
  switch (result.type) {
    case "ready-media": {
      const data = result.media[0] || {};
      if (nodeId) {
        const componentData = publicCommands?.getBlockComponentData(nodeId);
        publicCommands?.setBlock(nodeId, VIDEO_TYPE, {
          ...componentData,
          ...getVideoAttributes({ uploadData: data, componentData, config })
        });
        return;
      }
      queueMicrotask(() => {
        publicCommands.insertBlockWithBlankLines(
          VIDEO_TYPE,
          {
            ...getVideoAttributes({
              uploadData: data,
              componentData: null,
              config
            }),
            ...RICOS_DEFAULTS
          },
          {
            updateSelection: true
          }
        );
      });
      return;
    }
    case "file": {
      const files = result.file;
      const targetNodeId = nodeId || publicCommands.insertBlockWithBlankLines(VIDEO_TYPE, RICOS_DEFAULTS, {
        updateSelection: true
      });
      const file = Array.isArray(files) ? files[0] : files;
      const trackBi = services.uploadService.trackUploadBi(VIDEO_TYPE, file.size, file.name);
      try {
        const url = URL.createObjectURL(file);
        await Promise.resolve();
        publicCommands?.setBlock(targetNodeId, VIDEO_TYPE, {
          ...publicCommands?.getBlockComponentData(targetNodeId),
          video: { src: { url } },
          loading: true,
          error: null
        });
        trackBi?.start();
        const uploadFn = result.customUploadFn || handleFileUpload;
        if (!uploadFn) {
          logInvariant(Error("No upload function provided"));
          throw new Error("No upload function provided");
        }
        const uploadedFile = await upload(uploadFn, file);
        const uploadData = uploadedFile.data || {};
        const componentData = publicCommands?.getBlockComponentData(targetNodeId);
        publicCommands?.setBlock(targetNodeId, VIDEO_TYPE, {
          ...componentData,
          ...getVideoAttributes({ uploadData, componentData, config }),
          tempData: null,
          loading: null,
          error: null
        });
        URL.revokeObjectURL(url);
        trackBi?.success();
      } catch (error) {
        const componentData = publicCommands?.getBlockComponentData(targetNodeId);
        publicCommands?.setBlock(targetNodeId, VIDEO_TYPE, {
          ...componentData,
          error,
          loading: null
        });
        trackBi?.error(error);
        services.uploadService.notifyError(error);
      }
      return;
    }
    case "cancel": {
      return;
    }
    default: {
      console.error(unreachable(result));
      return;
    }
  }
};
export {
  handleVideoUpload
};
//# sourceMappingURL=handle-video-upload.js.map
